
import { Options, Vue } from 'vue-class-component';
import { demandProgressStatusItems } from "@/utils/configuration/demand-progress-config";
import i18n from '@/i18n';

@Options({
  props: ["taskDefinition"],
  watch: {
    taskDefinition: {
      handler(newTaskDefinition: string) {
        if (newTaskDefinition) {
          this.updateTaskIndex();
        }
      },
      immediate: true,
    },
  },
})
export default class DemandProgress extends Vue {
  taskDefinition!: string;
  nextItems: any;
  previousItems: any;
  thisTaskIndex: any = -1;

  get workflowItems() {
    return Object.values(demandProgressStatusItems);
  }

  isStepDone(index: number) {
    return this.thisTaskIndex > -1 && index <= this.thisTaskIndex;
  }

  getStepColor(index: number) {
    if (index < this.thisTaskIndex) {
      return 'green';
    } else if (index === this.thisTaskIndex) {
      return 'orange';
    }
    return 'grey';
  }

  getStepHeaderClass(index: number) {
    const classes = ['originationTextSize'];
    if (index === this.thisTaskIndex) {
      classes.push('demand-progress-step--current');
    }
    return classes.join(' ');
  }

  getTranslationForCurrentStatus(status: string) {
    return i18n.global.t(`enum.offer.ClientTaskDefinition.${status}`);
  }

  updateTaskIndex() {
    this.thisTaskIndex = this.workflowItems.findIndex((item: any) =>
      item.status.includes(this.taskDefinition)
    );

    this.previousItems = this.workflowItems.filter(
      (item: any, index: number) => index < this.thisTaskIndex
    );

    this.nextItems = this.workflowItems.filter(
      (item: any, index: number) => index > this.thisTaskIndex
    );

    this.syncCurrentStepHighlight();
  }

  syncCurrentStepHighlight() {
    this.$nextTick(() => {
      this.$nextTick(() => {
        const stepperRef = this.$refs.stepper as { $el?: HTMLElement } | undefined;
        const root = stepperRef?.$el;
        if (!root) return;

        root.querySelectorAll<HTMLElement>('.q-stepper__header .q-stepper__tab').forEach((tab, index) => {
          tab.classList.toggle('demand-progress-step--current', index === this.thisTaskIndex);
        });
      });
    });
  }

  mounted() {
    this.updateTaskIndex();
  }
}
